import Model, { belongsTo } from '@ember-data/model';

export default class WieConfigIcons extends Model {
  @belongsTo('wie-config/fill', { inverse: null, async: false, embedded: true }) fill;

  get isDirty() {
    return super.isDirty || this.fill.isDirty;
  }
}
